import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Check from "@material-ui/icons/Check";
import CustomToolbar from "../../CustomToolbar";
import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';


import IconButton from "@material-ui/core/IconButton";
import { Create, Delete, Add } from "@material-ui/icons";

import LinearProgress from '@material-ui/core/LinearProgress';

import { deepOrange, deepPurple } from '@material-ui/core/colors';

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import DateFnsUtils from '@date-io/date-fns';
import * as moment from 'moment'

import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import styles_theme from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import CustomToolbar_filter from "../../CustomToolbar_filter";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getSyntheticTrailingComments } from "typescript";

const useStyles_theme = makeStyles(styles_theme);

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "400",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },

};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginTop: "26px",
    width: "100%",
    color: 'red'
  },
  root_avatar: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1)
    }
  },
}));

const useStyles = makeStyles(styles);

export default function SummaryByBranch(props) {


  const roless = JSON.parse(localStorage.getItem('roles'));
  var curr_role = roless.filter((role) => role.formname == props.title);
  const user_id = JSON.parse(localStorage.getItem('user_id'));

  // const [color, setColor] = React.useState("red");
  const classes = useStyles();
  const classes_theme = useStyles_theme(); //theme css
  const classes_form = useStyles1(); //theme css
  let dat = new Date(Date.now());
  const [branchID, setBranchID] = useState([]);
  let date = new Date(Date.now()); date.setDate(date.getDate() - 7);

  const [Submitform, setSubmitform] = useState({
    user_id: user_id,
    driver_name: "",
    station_id: "",
    card_number: "",
    vehicle_id: "",
    odometer: "",
    date: dat,
    branch_id: ""


  }); //form submit
  const [Submitfilter, setSubmitfilter] = useState({
    driver_name: "",
    station_id: "",
    card_number: "",
    branch_id: "",
    vehicle_id: "",
    from_date: date,
    to_date: new Date(Date.now()),


  });

  const [items, setItems] = useState([]); //table items
  const [RowID, setRowID] = useState(-1); //table items

  const [loading, setloading] = useState(true); //loader


  const [modal_Title, setmodal_Title] = useState("Add"); //table items
  const [user, setUser] = useState([]);
  const [branch, setBranch] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [driver, setDriver] = useState([]);
  const [station, setStation] = useState([]);
  const [card, setCard] = useState([]);
  const [vehicle, setVehicle] = useState([]);

  const MySwal = withReactContent(Swal); //swal

  const classes1 = useStyles1();
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);



  const handleClose = () => {
    setOpen(false);
    setOpenFilter(false);
  };
  const handleclear = () => {
    if (Submitfilter.branch_id == branchID) {
      setSubmitfilter({
        driver_name: "",
        station_id: "",
        card_number: "",
        vehicle_id: "",
        from_date: date,
        to_date: new Date(Date.now()),
      })

    } else {
      setSubmitfilter({
        driver_name: "",
        station_id: "",
        card_number: "",
        branch_id: "",
        vehicle_id: "",
        from_date: date,
        to_date: new Date(Date.now()),
      })
    }

  };
  const handlechange_fromdat = (date) => {
    setSubmitfilter({
      ...Submitfilter,
      "from_date": new Date(date)
    });
  };

  const handlechange_todat = (date) => {
    setSubmitfilter({
      ...Submitfilter,
      "to_date": new Date(date)
    });
  };
  const handlesave_filter = () => {

    getTableData(0);
    handleClose();
  };
  const handlesave = () => {


    if (RowID == -1) {
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(Submitform),
      };

      fetch(`${process.env.REACT_APP_API_BASE_URL}` +
        "Transactions/store.php?action=1",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data == "Number Not Valid") {
            alert('Invalid Number !');
          } else if (data == "already used") {
            alert('Card number already used !');
          } else if (data == "Number not valid for this branch") {
            alert('Number not valid for this branch !');
          } else if (data == "Expired Number") {
            alert('Expired Number !');
          } else {
            var old_arr = items;

            old_arr.push(data[0]);

            setItems(old_arr);

            handleClose();
          }
        })
        .catch((error) => {
          alert("error");
          console.log("There was an error!", error);
        });
    } else {



      const requestOptions = {
        method: "POST",
        body: JSON.stringify({ ID: items[RowID].serial, ...Submitform }),
      };

      fetch(`${process.env.REACT_APP_API_BASE_URL}` +
        "Transactions/store.php?action=3",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data == "Number Not Valid") {
            alert('Invalid Number !');
          } else if (data == "already used") {
            alert('Card number already used !');
          } else if (data == "Number not valid for this branch") {
            alert('Number not valid for this branch !');
          } else if (data == "Expired Number") {
            alert('Expired Number !');
          } else {

            let arr_items = items;


            // 2. Make a shallow copy of the item you want to mutate
            arr_items[RowID] = data[0]
            // var old_arr = items;

            console.log(arr_items);

            // old_arr.push(data[0]);

            setItems(arr_items);
            handleClose();
          }
        })
        .catch((error) => {
          alert("error");
          console.log("There was an error!", error);
        });

    }
  };

  const save_clear = () => {


    if (RowID == -1) {
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(Submitform),
      };

      fetch(`${process.env.REACT_APP_API_BASE_URL}` +
        "Transactions/store.php?action=1",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data == "Number Not Valid") {
            alert('Invalid Number !');
          } else if (data == "already used") {
            alert('Card number already used !');
          } else if (data == "Number not valid for this branch") {
            alert('Number not valid for this branch !');
          } else if (data == "Expired Number") {
            alert('Expired Number !');
          } else {
            var old_arr = items;

            old_arr.push(data[0]);

            setItems(old_arr);

            setSubmitform({
              user_id: user_id,
              // driver_id:"",
              driver_name: "",
              station_id: "",
              card_number: "",
              vehicle_id: "",
              odometer: "",
              date: dat,
              branch_id: "",
            });
            alert("Successfully Saved");

          }
        })
        .catch((error) => {
          alert("error");
          console.log("There was an error!", error);
        });
    } else {



      const requestOptions = {
        method: "POST",
        body: JSON.stringify({ ID: items[RowID].serial, ...Submitform }),
      };

      fetch(`${process.env.REACT_APP_API_BASE_URL}` +
        "Transactions/store.php?action=3",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data == "Number Not Valid") {
            alert('Invalid Number !');
          } else if (data == "already used") {
            alert('Card number already used !');
          } else if (data == "Number not valid for this branch") {
            alert('Number not valid for this branch !');
          } else if (data == "Expired Number") {
            alert('Expired Number !');
          } else {

            let arr_items = items;


            // 2. Make a shallow copy of the item you want to mutate
            arr_items[RowID] = data[0]
            // var old_arr = items;

            console.log(arr_items);

            // old_arr.push(data[0]);

            setItems(arr_items);
            setSubmitform({
              user_id: user_id,
              // driver_id:"",
              driver_name: "",
              station_id: "",
              card_number: "",
              vehicle_id: "",
              odometer: "",
              date: dat,
              branch_id: ""
            });
            alert("Successfully Updated");

          }
        })
        .catch((error) => {
          alert("error");
          console.log("There was an error!", error);
        });

    }
  };
  const filter_listener = () => {
    setOpenFilter(true);
    getBranches();
    // getVehicle();
  };

  const handlechange_select_filter = (event) => {
    const { name, value } = event.target;

    setSubmitfilter({
      ...Submitfilter,
      [name]: value,
    });
  };

  function deleterows(row) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(row),
    };

    MySwal.fire({
      title: "<span style='color:white'>Are you sure? You won't be able to revert this!</span>",
      icon: "warning",
      toast: true,
      position: "top-end",
      background: "#212529",
      showCancelButton: true,
      confirmButtonColor: "#04d401",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_API_BASE_URL}` +
          "Transactions/store.php?action=2",
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            var data1 = items;

            row.map((row) => {
              data1 = data1.filter((user) => user.serial !== row.serial);
            });

            console.log(data1);

            setItems(data1);
          })
          .catch((error) => {
            alert("error");
            console.log("There was an error!", error);
          });

        //Swal.fire("Deleted!", "Your file has been deleted.", "success");
        Swal.fire({
          title: "<span style='color:white'>Deleted!</span>",
          icon: "success",
          toast: true,
          position: "top-end",
          background: "#212529",
          showCancelButton: false,
          timer: 3000,
          showConfirmButton: false
        })
      }
    });
  }
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}` + "Users/index.php?id=" + user_id)
      .then((response) => response.json())
      .then((data) => {
        if (data != null) {
          setUser(data[0]["username"]);
          setBranchID(data[0]["department"]);
          setSubmitfilter({
            ...Submitfilter,
            branch_id: data[0]["department"]
          })
          setBranch(data[0]["department_name"]);
          setloading(false)
        }
      })
      .catch((error) => {
        alert(error.toString());
      });
  }, []);

  const [page, setpage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);


  //get data for table
  const getTableData = (requiredPage) => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}Summary/SummaryByBranch.php?fromdat=${moment(Submitfilter.from_date).format("YYYY-MM-DD")}&todat=${moment(Submitfilter.to_date).format("YYYY-MM-DD")}&branch_id=${Submitfilter.branch_id}`)
      .then((response) => response.json())
      .then((data) => {
        //  alert("use");
        if (data != null) {
          setItems(data);
          setloading(false)
        }

      })
      .catch((error) => {
        alert(error.toString());

      });
  }
  useEffect(() => {
    getTableData(0);
  }, []);

  const getBranches = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}` + "Department/index.php?branch_id=" + branchID + "&action=1")
      .then((response) => response.json())
      .then((data) => {
        const ruleList = data.data.map((data) => (
          <MenuItem value={data.serial}>{data.name}</MenuItem>
        ));
        setBranchList(ruleList);
      })
      .catch((error) => {
        alert(error.toString());

      });
  }

  const list = [
    { value: "No cards available" }
  ];

  const columns = [
    {
      name: "branch_name",
      label: "المركز"
    },
    {
      name: "diesel",
      label: "(L)مازوت"
    },
    {
      name: "petrol",
      label: "(L)بنزين"
    }
  ];

  const options = {
    filterType: "dropdown",
    selectableRows: curr_role[0]['candelete'] == "1" ? true : false,

    onRowsDelete: (rowsDeleted) => {
      return false;
    },


    customToolbar: () => {

      return (<span>

        {
          <CustomToolbar_filter filter_listener={filter_listener} />
        }
      </span>);

    },
    filter: false,
  };

  return (
    <GridContainer>

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>{props.title} <span>-{branch}</span></h4>
            {/* <p className={classes.cardCategoryWhite}>
              Here is a subtitle for this table
            </p> */}
          </CardHeader>
          <CardBody>
            {loading ? <div style={{ textAlign: "center" }}><CircularProgress /></div> : <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title=""
                data={items}
                //{this.state.user}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
            }
          </CardBody>
        </Card>
      </GridItem>

      <div>


        <Dialog
          fullScreen
          open={openFilter}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes1.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes1.title}>
                {"Filter " + props.title}
              </Typography>
              <Button autoFocus color="inherit"
                onClick={handleclear}
              >
                Clear filters
              </Button>

              <Button autoFocus color="inherit"
                onClick={handlesave_filter}
              >
                save
              </Button>
            </Toolbar>
          </AppBar>
          <div style={{ padding: "50px" }}>
            <Grid container spacing={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="from_date"
                    label="From Date"
                    value={Submitfilter.from_date}
                    style={{ width: "100%" }}
                    onChange={handlechange_fromdat}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="to_date"
                    label="To Date"
                    value={Submitfilter.to_date}
                    style={{ width: "100%" }}
                    onChange={handlechange_todat}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  /></Grid>
              </MuiPickersUtilsProvider>

              <Grid item xs={12} sm={6}>
                <FormControl className={classes_form.formControl}>
                  <InputLabel id="branch_id-label">Branch Name</InputLabel>
                  <Select
                    labelId="branch_id-label"
                    name="branch_id"
                    value={Submitfilter.branch_id}
                    onChange={handlechange_select_filter}
                  >
                    {
                      branchList
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </Dialog>


      </div>
    </GridContainer>
  );

  function getMuiTheme() {
    return createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {},
          paper: {
            //  height: 'inherit',
            boxShadow: "none",
          },
          responsiveBase: {
            height: 'calc(100vh - 300px)!important'
          },
          responsiveScroll: {
            //  maxHeight: 'none',
            //  height: 'calc(100% - 128px)'
          },
        },
        MUIDataTableBodyRow: {
          root: {
            "&:nth-child(odd)": {
              backgroundColor: "#ebebeb",

            },
          },
        },
        MUIDataTableBodyCell: {
          root: {
            paddingTop: "0px",
            paddingBottom: "0px"
          },
        },
      },
    });
  }
}
